// extracted by mini-css-extract-plugin
export default {"linkCardContainer":"LinkCard_linkCardContainer__0Eh9J"};